import { isArray } from 'lodash'
import { ISSMLCheckAudioError, ISSMLCheckTagError } from 'ssml-check'

import { appendPositivitySign } from '../../../lib/number'
import { SsmlValidationIssue } from '../types'
import { shouldIssueBeTreatedAsWarning } from './issueCategorization/shouldIssueBeTreatedAsWarning'

export const isTokenExpired = (tokenTimestamp: number) => Date.now() - tokenTimestamp > 540000

export const formatSpeechRate = (languageSpeechRate: number | undefined) => {
  if (!languageSpeechRate) {
    return
  }

  return `${appendPositivitySign(languageSpeechRate)}.00%`
}

export const isTagIssue = (issue: SsmlValidationIssue): issue is ISSMLCheckTagError => {
  return 'tag' in issue
}

export const isAudioIssue = (issue: SsmlValidationIssue): issue is ISSMLCheckAudioError => {
  return 'detail' in issue
}

export const sortWarningsLast = (
  issues?: SsmlValidationIssue[]
): SsmlValidationIssue[] | undefined => {
  if (!isArray(issues)) {
    return issues
  }

  return issues.slice().sort((i1, i2) => {
    if (shouldIssueBeTreatedAsWarning(i1) && !shouldIssueBeTreatedAsWarning(i2)) {
      return 1
    }

    if (!shouldIssueBeTreatedAsWarning(i1) && shouldIssueBeTreatedAsWarning(i2)) {
      return -1
    }

    return 0
  })
}
